import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import _ from "lodash";
import { CommonLayout } from '../common/CommonLayout';
import { setInitStorage } from '../common/InitLocalStore';
import { sortingData } from '../common/Util';
import { ErrorModal } from '../common/ErrorModal';
import { ActionLoadingModal } from '../common/ActionLoadingModal';
import AddIntrusionPreventionItemModal from './AddIntrusionPreventionItemModal';
import UpdateIntrusionPreventionItemModal from './UpdateIntrusionPreventionItemModal';
import GlobalSettingsResponseModal from '../common/GlobalSettingsResponseModal';
import { getTenantList, getIntrusionPreventionList, clearIntrusionPreventionTable, clearTenantErrorResponseMessage, clearIntrusionPreventionErrorResponseMessage, sendIntrusionPreventionItem, sendRequestIntrusionPreventionDelete, updateIntrusionPreventionItem, clearNextPossibleResponseMessage } from '../../services/apiOperations';
import TableGrid from '../common/TableGrid';
import MultiSelectTextbox from '../common/MultiSelectTextbox';
import ConfirmationModal from '../common/ConfirmationModal';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/tableGrid.scss';
import { DIRECTION_OPTION } from '../common/Constants';
import ReactTooltip from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';

if (process.env.REACT_APP_HOST_ENV === "production") {
    console.log = function () { }
}

const CONSTANT_TYPE = {
    selectedTenant: "selectedTenant",
    direction: "direction"
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getIntrusionPreventionList: (referrer, queryFilterString, force) => dispatch(getIntrusionPreventionList(referrer, queryFilterString, force)),
    clearNextPossibleResponseMessage: () => dispatch(clearNextPossibleResponseMessage()),
    getTenantList: (referrer, queryFilterString) => dispatch(getTenantList(referrer, queryFilterString)),
    clearIntrusionPreventionTable: () => dispatch(clearIntrusionPreventionTable()),
    clearIntrusionPreventionErrorResponseMessage: () => dispatch(clearIntrusionPreventionErrorResponseMessage()),
    clearTenantErrorResponseMessage: () => dispatch(clearTenantErrorResponseMessage()),
})

const NULL_UNDEFINED_EMPTY_CHECK = [null, undefined, ""]

class IntrusionPreventionItems extends React.Component {
    constructor(props) {
        super(props);
        this.addIntrusionPreventionModalRef = React.createRef();
        this.updateIntrusionPreventionModalRef = React.createRef();
        setInitStorage(props.referrerHostname, queryString.parse(props.location.search))
        this.state = {
            queryParams: queryString.parse(props.location.search),
            kaseyaParams: queryString.parse(props.location.search),
            tenantList: [],
            filtered: [],
            rowData: [],
            stopInterval: false,
            updateInterval: false,
            clearFilterBool: false,
            clearSearchBox: false,
            selectedAction: '',
            showActionIntrusionPrevention: false,
            showErrorActionIntrusionPrevention: false,
            actionIntrusionPreventionMessage: '',
            columnDefs: [
                {
                    text: "Tenant Name", dataField: "tenant.name", sort: true, onSort: this.onSortChange, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Local Port", dataField: "localPorts", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Remote Port", dataField: "remotePorts", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Direction", dataField: "directionHR", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Remote Address", dataField: "remoteAddresses", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Comment", dataField: "comment", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                }
            ],
            defaultSorted: [{
                dataField: 'tenant.name',
                order: 'desc'
            }],
            currentPage: 1,
            pageWiseSelectedRows: [],
            loadingAction: false,
            sortChangeBool: false,
            successCount: 0,
            failCount: 0,
            clearSelection: false,
            selectedIntrusionPreventionBody: [],
            showDeleteConfirmationModal: false,
            DeleteConfirmationModalMessage: '',
            showAddIntrusionPreventionItem: false,
            showGlobalSettingsResponseModal: false,
            showUpdateIntrusionPreventionItemModal: false,
            messageGlobalSettingsResponseModal: '',
            machineName: "",
        }
        this.componentWillMountFunction()
    }

    componentWillMountFunction = () => {
        let queryFitlerString = queryString.parse(this.props.location.search)
        if (queryFitlerString !== "") {
            if (this.props.location.filtersObject) {
                let filters = this.state.filtered
                if (this.props.location.state) {
                    let newPropsSelectedTenantId = { value: this.props.location.state.id, type: CONSTANT_TYPE.selectedTenant }
                    filters.push(newPropsSelectedTenantId)
                }
                this.setState({
                    filtered: filters
                })
            }
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search);
        }
        else {
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.intrusion_prevention.force_limit_reached || this.props.intrusion_prevention.queued_job_exist || this.props.intrusion_prevention.scheduled) {
            this.showToast();
            this.props.intrusion_prevention.queued_job_exist = null
            this.props.intrusion_prevention.force_limit_reached = null
            this.props.intrusion_prevention.scheduled = null
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.intrusion_prevention.intrusion_prevention_list) !== JSON.stringify(prevState.rowData)) {
            this.setState({
                rowData: this.props.intrusion_prevention.intrusion_prevention_list
            })
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.intrusion_prevention.error_response_message) !== JSON.stringify(prevProps.intrusion_prevention.error_response_message)) {
            this.setState({
                IntrusionPreventionErrorResponse: this.props.intrusion_prevention.error_response_message
            })
        }
        if (JSON.stringify(this.props.tenants.tenant_list) !== JSON.stringify(prevProps.tenants.tenant_list)) {
            let createTenantListPair = []
            this.props.tenants.tenant_list.forEach((element) => {
                createTenantListPair.push({ value: element.id, label: element.showAs })
            })
            this.setState({
                tenantList: createTenantListPair
            })
            if (this.props.location.state === undefined) {
                this.getIntrusionPreventionData(false, false)
            }
        }
        if (
            this.props.settings.SophosIdTypeIsTenant &&
            JSON.stringify(this.props.settings.SophosIdTypeIsTenant) !==
            JSON.stringify(prevProps.settings.SophosIdTypeIsTenant)
        ) {
            this.getIntrusionPreventionData();
            const columDefs = [...this.state.columnDefs];
            const withoutTenantColumnDefs = _.remove(
                columDefs,
                (cols) => cols.dataField !== "tenant.name"
            );
            this.setState({ columnDefs: withoutTenantColumnDefs });
        }
    }

    componentWillUnmount() {
        this.clearErrorResponseToast()
        this.clearTenantErrorResponseToast()
    }

    onSortChange = () => {
        this.setState({
            sortChangeBool: !this.state.sortChangeBool
        })
    }

    clearNextpossibleToast = () => {
        this.props.clearNextPossibleResponseMessage()
    }

    showToast = () => {
        if (this.props.intrusion_prevention.force_limit_reached) {
            let last_sync_time = new Date(this.props.intrusion_prevention.last_force_update_time * 1000)
            let req_per_hour_diff = Math.round(60 / this.props.intrusion_prevention.req_per_hour)
            let next_response_time = new Date((this.props.intrusion_prevention.last_force_update_time * 1000) + (1000 * 60 * req_per_hour_diff))
            toast.error(`Last sync ran at ${last_sync_time.toLocaleTimeString()}. Next available sync at ${next_response_time.toLocaleTimeString()}`, { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.intrusion_prevention.queued_job_exist) {
            toast.error("Job already exist in queue", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
        else if (this.props.intrusion_prevention.scheduled) {
            toast.success("Force sync job scheduled successfuly", { containerId: 'A', onClose: () => this.clearNextpossibleToast() });
        }
    }

    filterData = (data) => {
        let result = []
        let appliedFilterLength = this.state.filtered.length;
        if (appliedFilterLength > 0) {
            for (let i = 0; i < data.length; i++) {
                let matchedCount = 0
                for (let j = 0; j < appliedFilterLength; j++) {
                    if (this.state.filtered[j].type === CONSTANT_TYPE.selectedTenant && data[i]["tenant"] && data[i]["tenant"]["id"].includes(this.state.filtered[j].value)) {
                        matchedCount++;
                    }
                    if (this.state.filtered[j].type === CONSTANT_TYPE.direction && data[i]["direction"] && (data[i]["direction"].toLowerCase().includes(this.state.filtered[j].value.toLowerCase()))) {
                        matchedCount++;
                    }
                }
                if (matchedCount === appliedFilterLength) {
                    result.push(data[i])
                }
            }
        } else {
            result = [...data]
        }
        return result
    }

    getPageWiseSelectedRowsFromTable = (currentPage, selectedRowData) => {
        let selectedIntrusionPreventionBody = []
        selectedRowData.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedIntrusionPreventionBody.push(eachRow)
            })
        })
        this.setState({
            currentPage: currentPage,
            pageWiseSelectedRows: selectedRowData,
            selectedIntrusionPreventionBody: selectedIntrusionPreventionBody
        })
    }

    setTablePage = (page) => {
        this.setState({
            currentPage: page,
        })
    }

    findFilterValueByType(arrayValue, searchType) {
        return arrayValue.type === searchType
    }

    selectFilters = (value, type, intervalInit = false) => {
        let filters = this.state.filtered
        let newfilterObj = { value: value, type: type }
        const obj = filters.find((arrayValue) => this.findFilterValueByType(arrayValue, newfilterObj.type))
        if (obj !== undefined) {
            const index = filters.indexOf(obj)
            filters.splice(index, 1)
        }
        if (value !== '')
            filters.push(newfilterObj)
        this.setState({
            filtered: filters,
            clearSearchBox: !this.state.clearSearchBox
        })
    }

    clearFilter() {
        let filters = []
        this.setState({ filtered: filters, clearFilterBool: !this.state.clearFilterBool, updateInterval: !this.state.updateInterval, stopInterval: false, selectedAction: "" })
    }

    getIntrusionPreventionData(fromOtherFilter = false, intervalInit = false, force = false) {
        if (this.props.location.search !== "") {
            if (!force) {
                this.props.clearIntrusionPreventionTable()
            }
            const queryParams = queryString.parse(this.props.location.search)
            if (force) {
                let filters = this.state.filtered;
                let filteredObject = filters.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant));
                if (filteredObject) {
                    queryParams.sophosTenantId = filteredObject.value
                }
            }
            const queryFilter = queryString.stringify(queryParams)
            this.props.getIntrusionPreventionList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), "?" + queryFilter, force)
        }
        else {
            this.props.getIntrusionPreventionList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), force)
        }
    }

    getIntrusionPreventionSelectedId = (selectedId) => {
        this.setState({
            singleSelectedIntrusionPreventionId: selectedId
        })
    }

    tablegridMessage() {
        if (!this.props.intrusion_prevention.is_loading) {
            let filteredObject = this.state.filtered.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant))
            if (filteredObject !== undefined) {
                let checkTenantDetails = this.props.tenants.tenant_list.find((tenantValue) => tenantValue.id === filteredObject.value)
                if (checkTenantDetails) {
                    if (checkTenantDetails.apiHost === null || checkTenantDetails.apiHost === "" || checkTenantDetails.apiHost === "NULL" || checkTenantDetails.apiHost === "null" || checkTenantDetails.apiHost === undefined) {
                        return { message: 'This account has not been activated; <br/>Please activate from <a target="_blank" href="https://cloud.sophos.com/">Sophos Central Administration Console</a>', type: "error" }
                    }
                    else {
                        return { message: "No intrusion prevention found to match your search.", type: "info" }
                    }
                }
                else {
                    return { message: "No intrusion prevention found to match your search.", type: "info" }
                }

            }
            else {
                return { message: "No intrusion prevention found to match your search.", type: "info" }
            }
        }
        else {
            return { message: "Loading....", type: "info" }
        }
    }

    clearErrorResponseToast = () => {
        this.props.clearIntrusionPreventionErrorResponseMessage()
    }

    clearTenantErrorResponseToast = () => {
        this.props.clearTenantErrorResponseMessage()
    }

    getNonSelectableRows = (allRows) => {
        let allNonselectableRowIds = []
        if (this.state.selectedAction !== "") {
            allRows.forEach((element) => {
                if (element.intrusionPreventionAction) {
                    allNonselectableRowIds.push(element.id)
                }
            })
        }
        else {
            allNonselectableRowIds = []
        }
        return allNonselectableRowIds
    }

    closeActionIntrusionPrevention = () => {
        if (this.state.pageWiseSelectedRows.length === 0 || this.state.pageWiseSelectedRows[0].selectedRow.length === 0) {
            this.setState({
                showErrorActionIntrusionPrevention: false,
                showActionIntrusionPrevention: false,
                actionIntrusionPreventionMessage: ""
            })
        }
        else {
            this.setState({
                showActionIntrusionPrevention: false,
                showErrorActionIntrusionPrevention: false,
                actionIntrusionPreventionMessage: "",
                clearSearchBox: !this.state.clearSearchBox,
                selectedAction: ""
            }, () => {
                this.getIntrusionPreventionData()
            })
        }
    }

    AddIntrusionPreventionActionHandler = (ItemData) => {
        this.setState({
            loadingAction: true,
            actionIntrusionPreventionMessage: ""
        }, () => {
            let requestBody = ItemData
            sendIntrusionPreventionItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showAddIntrusionPreventionItem: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Intrusion prevention added successfully."
                    }, this.getIntrusionPreventionData)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionIntrusionPrevention: true,
                        actionIntrusionPreventionMessage: errMessage
                    })
                })
        })
    }

    AddIntrusionPreventionAction = () => {
        this.setState({
            showAddIntrusionPreventionItem: true,
        });
    }

    CloseIntrusionPreventionAction = () => {
        this.setState({
            showAddIntrusionPreventionItem: false,
        })
    }

    CloseGlobalSettingsResponseModal = () => {
        this.setState({
            showGlobalSettingsResponseModal: false,
        })
    }

    ShowDeleteConfirmationModal = () => {
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: true,
            DeleteConfirmationModalMessage: `Are you sure you want to delete <strong>${this.state.pageWiseSelectedRows[0].selectedRow.length}</strong> selected intrusion prevention(s)?<small class="form-text text-muted pt-3"><strong>Note: </strong>Delete action may take some time to reflect in our systems.</small>`
        })
    }

    DeleteIntrusionPreventionHandler = () => {
        let selectedItemsBody = []
        this.state.pageWiseSelectedRows.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedItemsBody.push({ "itemId": eachRow.id, "tenantId": eachRow.tenant.id, "dataRegion": eachRow.tenant.dataRegion })
            })
        })
        let requestBody = {
            "items": selectedItemsBody,
        }
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: false,
        }, () => {
            sendRequestIntrusionPreventionDelete(
                this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"),
                requestBody,
                this.props.location.search
            )
                .then(res => {
                    this.setState({
                        loadingAction: false,
                        clearSelection: !this.state.clearSelection,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Deletion request received successfully."
                    })
                    setTimeout(() => {
                        this.getIntrusionPreventionData()
                    }, 1000)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionIntrusionPrevention: true,
                        actionIntrusionPreventionMessage: errMessage,
                    })
                })
        })
    }

    CloseDeleteConfirmationModal = () => {
        this.setState({
            showDeleteConfirmationModal: false
        })
    }

    UpdateIntrusionPreventionActionHandler = (ItemData) => {
        this.setState({
            loadingAction: true,
            actionIntrusionPreventionMessage: ""
        }, () => {
            let requestBody = ItemData
            updateIntrusionPreventionItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showUpdateIntrusionPreventionItemModal: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Intrusion prevention updated successfully."
                    }, this.getIntrusionPreventionData)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionIntrusionPrevention: true,
                        actionIntrusionPreventionMessage: errMessage
                    })
                })
        })
    }

    UpdateIntrusionPreventionAction = () => {
        if (this.updateIntrusionPreventionModalRef.current) {
            this.updateIntrusionPreventionModalRef.current.resetModal();
        }
        this.setState({
            showUpdateIntrusionPreventionItemModal: true,
        })
    }

    CloseUpdateIntrusionPreventionAction = () => {
        this.setState({
            showUpdateIntrusionPreventionItemModal: false,
        })
    }

    render() {
        let tenantCheck = this.state.filtered.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant))
        let checkTenantDetails;
        if (tenantCheck)
            checkTenantDetails = this.props.tenants.tenant_list.find((tenantValue) => tenantValue.id === tenantCheck.value)

        const tenantsWithDataRegionNull = [];
        let clearTenantSelect = false;
        this.props.tenants.tenant_list.forEach((tenant) => {
            if (
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.dataRegion) ||
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.apiHost)
            ) {
                tenantsWithDataRegionNull.push(tenant.id);
            }
        });
        let selectedTenantId = this.state.filtered.find(
            (arrayValue) => arrayValue.type === CONSTANT_TYPE.selectedTenant
        );
        if (
            selectedTenantId &&
            tenantsWithDataRegionNull.length &&
            tenantsWithDataRegionNull.filter(
                (item) => item === selectedTenantId.value
            ).length
        ) {
            clearTenantSelect = true;
        }

        let messageForForceSync = this.props.settings?.SophosIdTypeIsTenant ? this.props.intrusion_prevention && this.props.intrusion_prevention.last_updated_times && this.props.intrusion_prevention.last_updated_times[this.props.settings?.SophosTenantId] ? 'Last Force Sync Time: ' + moment.unix(this.props.intrusion_prevention.last_updated_times[this.props.settings?.SophosTenantId]).format('YYYY-MM-DD HH:mm:ss') : '' : selectedTenantId && selectedTenantId.value && this.props.intrusion_prevention.last_updated_times && this.props.intrusion_prevention.last_updated_times[selectedTenantId.value] ? 'Last Force Sync Time: ' + moment.unix(this.props.intrusion_prevention.last_updated_times[selectedTenantId.value]).format('YYYY-MM-DD HH:mm:ss') : ''
        
        return (
            <CommonLayout title="Intrusion Prevention" displayTitle={true}>
                <ErrorModal
                    show={this.props.tenants.error_response_message !== null || this.props.intrusion_prevention.error_response_message !== null}
                    closeModal={() => {
                        this.props.tenants.error_response_message !== null ?
                            this.clearTenantErrorResponseToast()
                            :
                            this.clearErrorResponseToast()
                    }}
                    modalMessage={
                        this.props.tenants.error_response_message !== null && this.props.intrusion_prevention.error_response_message === null ?
                            this.props.tenants.error_response_message
                            :
                            this.props.intrusion_prevention.error_response_message}
                />
                <ErrorModal
                    show={this.state.showErrorActionIntrusionPrevention}
                    closeModal={this.closeActionIntrusionPrevention}
                    modalMessage={this.state.actionIntrusionPreventionMessage}
                />
                <ActionLoadingModal show={this.state.loadingAction} />
                <ConfirmationModal
                    show={this.state.showDeleteConfirmationModal}
                    confirmAction={() => this.DeleteIntrusionPreventionHandler()}
                    closeModal={this.CloseDeleteConfirmationModal}
                    modalMessage={this.state.DeleteConfirmationModalMessage}
                />
                <AddIntrusionPreventionItemModal
                    {...this.props}
                    show={this.state.showAddIntrusionPreventionItem}
                    closeModal={this.CloseIntrusionPreventionAction}
                    confirmModal={this.AddIntrusionPreventionActionHandler}
                    ref={this.addIntrusionPreventionModalRef}
                />
                <UpdateIntrusionPreventionItemModal
                    {...this.props}
                    show={this.state.showUpdateIntrusionPreventionItemModal}
                    update_data={this.state.selectedIntrusionPreventionBody}
                    closeModal={this.CloseUpdateIntrusionPreventionAction}
                    confirmModal={this.UpdateIntrusionPreventionActionHandler}
                    ref={this.updateIntrusionPreventionModalRef}
                />
                <GlobalSettingsResponseModal
                    {...this.props}
                    show={this.state.showGlobalSettingsResponseModal}
                    closeModal={this.CloseGlobalSettingsResponseModal}
                    message={this.state.messageGlobalSettingsResponseModal}
                />
                <ToastContainer
                    position="top-right"
                    autoClose={7000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable={false}
                    pauseOnHover={false}
                    enableMultiContainer
                    containerId={'A'}
                />
                <div className="row mt-2 mx-1">
                    <div className="col-8">
                        <div className="input-group-append row">
                            {!this.props.settings.SophosIdTypeIsTenant && 
                                <div className="col-sm-3 px-0 mx-1 text-left mb-2">
                                    <div className="col-sm-12 px-0 mx-1 text-left">
                                        <span>Tenants</span>
                                        <MultiSelectTextbox
                                            options={this.state.tenantList.sort(sortingData)}
                                            isMulti={false}
                                            filteredSelectedValue={
                                                this.state.filtered.find((arrayValue) =>
                                                    this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)) ?
                                                    this.state.tenantList.filter((element) => element.value === this.state.filtered.find((arrayValue) =>
                                                        this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)).value)
                                                    : []
                                            }
                                            onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.selectedTenant)}
                                            clearValue={this.state.clearFilterBool}
                                            clearable={true}
                                            isLoading={this.props.tenants.is_loading}
                                            disabledSelect={this.props.intrusion_prevention.is_loading}
                                        />
                                    </div>
                                </div>
                            }
                            <div className="col-sm-2 px-0 mx-1 text-left">
                                <span>Direction</span>
                                <MultiSelectTextbox
                                    options={DIRECTION_OPTION}
                                    isMulti={false}
                                    filteredSelectedValue={
                                        this.state.filtered.find((arrayValue) =>
                                            this.findFilterValueByType(arrayValue, CONSTANT_TYPE.direction))
                                    }
                                    onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.direction)}
                                    clearable={true}
                                    clearValue={this.state.clearFilterBool}
                                />
                            </div>
                            <div className="col-1 text-left mt-3">
                                <button type="button" className="btn btn-secondary btn-sm ml-2" disabled={this.props.intrusion_prevention.is_loading} onClick={this.clearFilter.bind(this)}>Clear</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 justify-content-end flex pt-3 pr-0" style={{ display: "flex" }}>

                        <button style={{ maxHeight: "29px" }} type="button" className="btn btn-primary btn-sm mr-2 " onClick={this.AddIntrusionPreventionAction}>
                            Add
                        </button>
                        <button style={{ maxHeight: "29px" }} disabled={!(this.state.selectedIntrusionPreventionBody && this.state.selectedIntrusionPreventionBody.length === 1)} type="button" className="btn btn-primary btn-sm mr-2" onClick={this.UpdateIntrusionPreventionAction}>
                            Update
                        </button>
                        <button style={{ maxHeight: "29px" }} disabled={!(this.state.selectedIntrusionPreventionBody && this.state.selectedIntrusionPreventionBody.length > 0)} type="button" className="btn btn-primary btn-sm mr-2" onClick={this.ShowDeleteConfirmationModal}>
                            Delete
                        </button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-outline-primary btn-sm" disabled={((tenantCheck === undefined || checkTenantDetails === undefined) && !this.props.settings.SophosIdTypeIsTenant) || clearTenantSelect} onClick={this.getIntrusionPreventionData.bind(this, false, false, true)}><i className="fa fa-refresh" /> Force Sync</button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-primary round-help-btn ml-2 btn-sm" data-tip={this.props.intrusion_prevention.req_per_hour !== null ? `Maximum of ${this.props.intrusion_prevention.req_per_hour}x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}` : `Maximum of 4x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}`} data-for='helpTime'><i className="fa fa-question" /></button>
                        <ReactTooltip id="helpTime" effect="solid" type="info" place="left" />
                    </div>
                </div>
                <div className="row mt-2 mx-1">
                    <div className="col-12 text-right">
                        <b>{messageForForceSync}</b>
                    </div>
                </div>
                <div className="row m-1 card-content-height">
                    <div className="col-md-12 pr-1">
                        <TableGrid
                            clearValue={this.state.clearFilterBool}
                            defaultSortedCol={this.state.defaultSorted}
                            columnStructure={this.state.columnDefs}
                            responseData={this.filterData(this.state.rowData)}
                            loading={this.props.intrusion_prevention.is_loading}
                            stateObject={this.props.intrusion_prevention}
                            pageSize={this.filterData(this.state.rowData).length < this.props.intrusion_prevention.page_size ? this.filterData(this.state.rowData).length : this.props.intrusion_prevention.page_size}
                            filtered={this.state.filtered}
                            noDataText={this.tablegridMessage()}
                            keyField="_id"
                            moduleName="IntrusionPrevention"
                            clearSearchBox={this.state.clearSearchBox}
                            note="Intrusion prevention will be displayed in some time if you have configured settings recently."
                            singleSelectedRow={(selectedId) => this.getIntrusionPreventionSelectedId(selectedId)}
                            pageWiseSelectedRowsFromTable={(currentPage, selectedRowData) => this.getPageWiseSelectedRowsFromTable(currentPage, selectedRowData)}
                            onPageChangeEvent={(page) => this.setTablePage(page)}
                            nonSelectableRows={this.getNonSelectableRows(this.filterData(this.state.rowData))}
                            onSortChange={this.state.sortChangeBool}
                            onPerformAction={this.state.clearSelection}
                        />
                    </div>
                </div>
            </CommonLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntrusionPreventionItems)